<template>
  <div class="createPost-container">
    <el-form
      ref="postForm"
      v-loading="loading"
      :rules="rules"
      :model="postForm"
      class="form-container"
      label-width="180px"
      label-position="left"
    >
      <el-form-item label="端口" prop="platform_id">

        <div v-if="isEdit">
          {{
            detail | getRowData(['platform', 'platform_name'])
          }}
        </div>
        <el-select
          v-else
          v-model="postForm.platform_id"
          placeholder="请选择端口"
          class="filter-item filter-form-item status-select"
          @change="handleChangePlatform"
        >
          <el-option
            v-for="item in platformList"
            :key="item.id"
            :label="item.platform_name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="角色名称" prop="name">
        <span v-if="isRead">{{ postForm.name }}</span>
        <el-input
          v-else
          v-model="postForm.name"
          placeholder="请输入角色名称"
          type="text"
          class="input-form"
        />
      </el-form-item>

      <el-form-item label="菜单选择">
        <el-tree
          ref="tree"
          :data="allMenus"
          :props="treeProps"
          show-checkbox
          default-expand-all
          node-key="id"
          :default-checked-keys="postForm.menus"
          @check-change="handleCheckChange"
        />
      </el-form-item>

      <el-form-item>
        <el-button
          v-if="!isRead"
          :loading="loading"
          type="primary"
          @click="submitForm('postForm')"
        >
          保存
        </el-button>
        <el-button
          v-else
          :loading="loading"
          @click="$router.go(-1)"
        >
          返回上一页
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import _ from 'lodash'
import { fetchUserRoleDetail, updateRole, createUserRole, fetchAllMenu } from '@/api/role'
import { fetchPlatformList } from '@/api/common'
import { RES_SUCCESS_CODE } from '@/constances/server'
import { scrollToFormView } from '@/utils'
import { filterMenuRoutes } from '@/store/modules/permission'

const defaultForm = {
  name: undefined, // 角色名称
  menus: [] // 菜单
}

export default {
  name: 'RoleDetail',
  filters: {
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      detail: {},
      isRead: false, // 只读
      loading: false,
      id: undefined, // 角色id
      addParamsLoading: false, // 新增参数loading
      postForm: _.cloneDeep(defaultForm),
      defaultPostForm: _.cloneDeep(defaultForm),
      allMenus: [],
      rules: {
        platform_id: [{ required: true, message: '请选择端口', trigger: 'blur' }],
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }]
      },
      tempRoute: {},
      platformList: [],
      treeProps: {
        label: 'name',
        children: 'children'
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id
      const isRead = this.$route.query.isRead
      this.isRead = isRead === '1'
      this.getDetail(id)
    } else {
      this.getPlatforms()
    }

    // Why need to make a copy of this.$route here?
    // Because if you enter this page and quickly switch tag, may be in the execution of the setTagsViewTitle function, this.$route is no longer pointing to the current page
    // https://github.com/PanJiaChen/vue-element-admin/issues/1221
    this.tempRoute = Object.assign({}, this.$route)
  },
  methods: {
    // 标题设置
    setTagsViewTitle(title = '') {
      const route = Object.assign({}, this.tempRoute, { title: `${title}` })
      this.$store.dispatch('tagsView/updateVisitedView', route)
    },
    setPageTitle(title = '') {
      document.title = `${title}`
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate)
    },
    getCheckedNodes() {
      return this.$refs.tree.getCheckedNodes(false, true)
    },

    submitForm() {
      if (this.isEdit) {
        this.updateRole()
      } else {
        this.createRole()
      }
    },

    // 表单验证
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.postForm.validate((valid, object) => {
          console.log(this.postForm, valid)
          if (valid) {
            this.loading = true
            const payload = _.cloneDeep(this.postForm)
            const menus = this.getCheckedNodes()
            if (menus.length === 0) {
              this.$message.error('请选择菜单~')
              reject('表单校验没通过')
            } else {
              payload.menus = menus.map(item => item.id)
              resolve(payload)
            }
          } else {
            scrollToFormView.apply(this)
            console.log('error submit!!')
            reject('表单校验没通过')
          }
        })
      })
    },

    // 选择端口
    handleChangePlatform(value) {
      this.menus = []
      this.getMenus(value)
    },

    async createRole() {
      const payload = await this.validateForm()
      if (payload) {
        try {
          this.loading = true
          const res = await createUserRole({
            ...payload
          })
          this.loading = false
          if (res.code === RES_SUCCESS_CODE) {
            this.$message.success('创建成功')
            this.$router.push({
              path: `/account/role/list`
            })
          }
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      }
    },

    async updateRole() {
      const payload = await this.validateForm()
      if (payload) {
        try {
          this.loading = true
          const res = await updateRole(this.postForm.id, {
            ...payload
          })
          this.loading = false
          if (res.code === RES_SUCCESS_CODE) {
            this.$message.success('编辑成功')
            this.$router.push({
              path: `/account/role/list`
            })
          }
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      }
    },

    // 重置表单
    resetForm(formName) {
      this.postForm = _.cloneDeep(this.defaultPostForm)
      this.$refs[formName].resetFields()
    },

    // 获取端口列表
    async getPlatforms() {
      try {
        const res = await fetchPlatformList()
        if (res && res.code === RES_SUCCESS_CODE) {
          this.platformList = res.data.data.filter(role => role.platform_name !== 'CMS门店管理后台')
        }
      } catch (e) {
        console.log(e)
      }
    },

    // 获取详情
    async getDetail(role_id) {
      this.loading = true
      const _this = this
      this.loading = true
      try {
        const res = await fetchUserRoleDetail(role_id)
        const { name, menus, platform_id, status } = res.data
        this.detail = res.data
        this.postForm = {
          platform_id,
          id: role_id,
          name,
          menus: _this.getMenuValue(menus),
          status
        }
        console.log(this.postForm)
        this.loading = false
        this.getMenus(res.data.platform_id)

        console.log(this.postForm)
      } catch (e) {
        this.loading = false
        console.log(e)
      } finally {
        this.loading = false
      }
    },

    // 获取菜单
    getMenus(platform_id) {
      this.loading = true
      fetchAllMenu({
        platform_id,
        status: 1
      }).then(res => {
        this.loading = false
        if (res && res.code === RES_SUCCESS_CODE) {
          this.allMenus = filterMenuRoutes(res.data, !!this.isRead)
        }
      })
    },
    getMenuValue(menus) {
      let _menus = []
      menus.forEach(menu => {
        // 有子节点 就传子节点，没有就传自己
        if (menu.children) {
          _menus = _menus.concat(this.getMenuValue(menu.children))
        } else {
          _menus.push(menu.id)
        }
      })
      console.log(_menus)
      return _menus
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/form-detail.scss";
.cash-tips {
  margin-bottom: 20px;
  color: #f00;
}

.input-form {
  width: 300px;
}
</style>
